// Google Analytics Tracking ID
// https://github.com/truethari/walstan-portfolio#-google-analytics
export const TRACKING_ID = "G-MT635J09JT";
